import modalMixin from '../../../mixins/_modal';

/**
 * お届け日設定コンポーネント(主にきょうつく・あすつくstatusデータ調整)
 */
export default {
    name: 'DeliveryDaySettings',
    template: '#delivery_day_settings_template',
    data() {
        return {
            // 編集中のデータ
            data: {}
        };
    },
    props: {
        modelValue: {
            type: Object,
            default: () => ({}),
            required: false
        }
    },
    mixins: [
        modalMixin,
    ],
    emits: ['update:modelValue'],
    methods: {
        // モーダルを開いたら編集中データへ代入
        opening: function () {
            this.data = _.cloneDeep(this.modelValue);
        },
        // データを更新してモーダルを閉じる
        update: function (event) {
            // バリデーションエラーの場合はそのままフォーム送信する
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();
            this.emitUpdatValue();
            this.close();
        },

        // -------------------------
        // emit
        // -------------------------

        // 編集内容で更新
        emitUpdatValue: function () {
            this.$emit('update:modelValue', this.data);
        }
    }
};
